export default __webpack_public_path__ + "static/media/ER13.577c88e4.png";